import Link from "next/link";

import { toWebUrl } from "@shared/utils";

type HeaderProps = {
  /**
   * The name of the organization
   */
  orgName?: string;
  /**
   * The URL to the organization's logo
   */
  logoUrl?: string;
  /**
  /**
   * Alternative text for the logo
   */
  logoAlt?: string;
  /**
   * The URL to the organization's website
   */
  website: string;
};

export default function Header({
  orgName,
  website,
  logoUrl,
  logoAlt,
}: HeaderProps) {
  if (!logoUrl) return null;

  const logo = (
    <>
      {orgName && <span className="sr-only">{orgName}</span>}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img className="h-20 w-auto" src={logoUrl} alt={logoAlt} />
    </>
  );

  // The organizer types this in, so it may be something we shouldn't link to at all — see
  // toWebUrl. The logo then renders unlinked rather than as an href on our own origin.
  const websiteUrl = toWebUrl(website);

  return (
    <header>
      {websiteUrl ? (
        <Link href={websiteUrl} target="_blank" rel="noopener noreferrer">
          {logo}
        </Link>
      ) : (
        logo
      )}
      <hr className="my-8" />
    </header>
  );
}
